<template>
    <div class="p-3 d-flex flex-column" style="overflow: hidden">

        <assets-filter-component />

        <div
            class="scroll flex-grow-1"
            ref="equipmentsList"
        >
            <div
                class="task"
                :class="{ 'selectable': selectMode }"
                v-for="equipment in filteredEquipments.data"
                :key="equipment.id"
                :draggable="true"
                @dragstart="dragStart($event, equipment.id)"
                @click="selectMode && onSelect(equipment)"
            >
                <div
                    class="py-2 task__title"
                    :style="equipmentStyle(equipment)"
                >
                    <p class="m-0 font-weight-bold d-flex align-items-center">
                        <span>{{ equipment.title }}</span>
                        <span v-if="selectMode && isSelected(equipment.id)" class="ml-auto">
                            <i class="icofont-check selected-check-icon"></i>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var qs = require('qs');
import AssetsFilterComponent from "./filter/AssetsFilterComponent";
import {emitter} from "../../../plugins/Mitt";
import {mapState} from "vuex";
import { buildPlanningFilter } from "../../../utils/planning/buildPlanningFilter";

export default {
    components: {
        AssetsFilterComponent,
    },
    props: {
        selectMode: {
            type: Boolean,
            default: false,
        },
        selectedIds: {
            type: Array,
            default: () => [],
        },
    },
    data(){
        return {
            canLoadMore: true,
            filteredEquipments: {
                total: 0,
                per_page: 100,
                from: 1,
                to: 0,
                current_page: 1,
                data: [],
            },
        }
    },
    computed: {
        ...mapState('planningFilter', [
            'filter',
            'sort',
        ]),
    },
    methods:{
        getEquipmentsList() {
            if ( (this.loading && this.filteredEquipments.current_page === 1) || !this.canLoadMore ) return;
            this.loading = true;
            const url = route('equipments.list');

            const allowedFilters = ['name', 'free', 'department_ids', 'team_ids'];
            const dateOptions = this.filter.free ? { date: this.filter.free } : {};
            const filter = buildPlanningFilter(this.filter, allowedFilters, dateOptions);

            const params = {
                page: this.filteredEquipments.current_page,
                filter: filter,
                sort: this.sort,
            };
            axios
                .get(url, {
                    params,
                    paramsSerializer: (params) => {
                        // Ensure empty arrays are represented as empty strings to be included in the query
                        if (params.filter?.department_ids?.id && Array.isArray(params.filter.department_ids.id) && params.filter.department_ids.id.length === 0) {
                            params.filter.department_ids.id = [''];
                        }
                        if (params.filter?.team_ids?.id && Array.isArray(params.filter.team_ids.id) && params.filter.team_ids.id.length === 0) {
                            params.filter.team_ids.id = [''];
                        }
                        return qs.stringify(params, {
                            encode: false,
                            arrayFormat: 'brackets'
                        });
                    },
                })
                .then((response) => {
                    const newEquipmentData = response?.data?.equipments;
                    if (!newEquipmentData || !Array.isArray(newEquipmentData.data)) {
                        this.canLoadMore = false; // Stop loading if structure is wrong
                        if (this.filteredEquipments.current_page === 1) this.filteredEquipments.data = [];
                        return;
                    }

                    const newItemsCount = newEquipmentData.data.length;

                    if (newEquipmentData.current_page > 1) {
                        this.filteredEquipments.data = this.filteredEquipments.data.concat(
                            newEquipmentData.data,
                        );
                    } else {
                        // Replace data, but merge other pagination properties
                        this.filteredEquipments = newEquipmentData;
                    }

                    this.filteredEquipments.current_page = newEquipmentData.current_page;

                    this.canLoadMore = newItemsCount === this.filteredEquipments.per_page && newItemsCount > 0;
                })
                .catch(error => { // *** ADD/ENSURE CATCH BLOCK ***
                    this.canLoadMore = false; // Stop loading on error
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleScroll() {
            const listElm = this.$refs.equipmentsList;

            if (!listElm || this.loading || !this.canLoadMore) return;

            const currentScroll = listElm.scrollTop;
            const clientHeight = listElm.clientHeight;
            const scrollHeight = listElm.scrollHeight;
            const buffer = 100; // Your buffer
            const triggerPoint = scrollHeight - buffer;
            const currentPosition = currentScroll + clientHeight;

            if (currentPosition >= triggerPoint) {
                // Log when the condition is met *before* fetching

                this.filteredEquipments.current_page += 1;
                this.getEquipmentsList();
            }
        },
        equipmentsListControlPanelScroller() {
            this.$nextTick(() => {
                const listElm = this.$refs.equipmentsList;

                if (listElm && !this.scrollListenerAttached) {
                    listElm.addEventListener('scroll', this.handleScroll);
                    this.scrollListenerAttached = true;
                } else if (listElm && this.scrollListenerAttached) {
                }
            });
        },
        removeScrollListener() {
            const listElm = this.$refs.equipmentsList;
            if (listElm && this.scrollListenerAttached) {
                listElm.removeEventListener('scroll', this.handleScroll);
                this.scrollListenerAttached = false;
            }
        },
        equipmentStyle: function (equipment) {

            return {
                'background-color': equipment.status.color,
                'color': equipment.status.text_color,
            }
        },
        dragStart(event, equipmentId) {
            this.$store.commit('planning/resetDragStartInfo');
            event.dataTransfer.setData('equipmentId', equipmentId);
        },
        onSelect(equipment) {
            this.$emit('selected', { type: 'equipment', id: equipment.id, title: equipment.title });
        },
        isSelected(id){
            return Array.isArray(this.selectedIds) && this.selectedIds.includes(id);
        },
    },
    mounted(){
        this.getEquipmentsList();
        this.equipmentsListControlPanelScroller();

        emitter.on('planning-slots-changed', () => {
            console.log('planning-slots-changed');
            this.filteredEquipments.current_page = 1;
            this.canLoadMore = true;
            this.getEquipmentsList();
        });
        emitter.on('planning-drop-handled', () => {
            console.log('planning-drop-handled');
            this.filteredEquipments.current_page = 1;
            this.canLoadMore = true;
            this.getEquipmentsList();
        });
        emitter.on('slot-deleted', () => {
            console.log('slot-deleted');
            this.filteredEquipments.current_page = 1;
            this.canLoadMore = true;
            this.getEquipmentsList();
        });
    },
    watch: {
        filter: {
            handler() {
                this.canLoadMore = true;
                this.filteredEquipments.current_page = 1;
                this.filteredEquipments.data = [];

                this.getEquipmentsList();
            },
            deep: true,
        },
        sort: {
            handler() {
                this.canLoadMore = true;
                this.filteredEquipments.current_page = 1;
                this.filteredEquipments.data = [];

                this.getEquipmentsList();
            },
            deep: true,
        },
    }
}
</script>

<style>
.scroll {
    overflow-y: auto;
    overflow-x: hidden;
}

.task.selectable{
    cursor: pointer;
}

.selected-check-icon{
    color: #fff;
    font-size: 1.2em;
}
</style>